import DailyReportPage from "./DailyReportPage"
export default DailyReportPage
